import { getGuessStatuses } from '../../lib/statuses'
import { MiniCell } from './MiniCell'

type Props = {
  guess: string,
  hint: string
}

export const MiniCompletedRow = ({ guess, hint }: Props) => {
  const statuses = getGuessStatuses(guess)

  return (
    <div className="flex justify-center mb-1">
      {guess.split('').map((letter, i) => (
        <MiniCell key={i} status={statuses[i]} letter={hint!==''? hint[i]:''} />
      ))}
    </div>
  )
}
